export default __webpack_public_path__ + "static/media/ANJING.9f41e28c.png";